import OrderItemsTable from './OrderItemsTable';

export default OrderItemsTable;
